import * as Sentry from '@sentry/gatsby';
import { sentryConfigActivationTransferCover } from '@agria/utils/src/sentryConfigActivationTransferCover';

Sentry.init(sentryConfigActivationTransferCover);
